// The consent sentence a new account is created with (F-CMP-06, spec/07 §3.1): "I agree to the Terms of
// Service and the Privacy Policy", with the two documents in force linked inside it. Shared by sign-up and
// by accepting a phone invitation with a number that has no account yet (ADR-0046), so both ask the same
// way and send the same versions.

import { useTranslation } from '@clavian/i18n/react';
import type { ReactNode } from 'react';

import type { BrandLegal } from '../api/meta';

/** Where the two links stand in the consent sentence: private-use characters no translation contains, split out again below. */
const TERMS_MARK = '';
const PRIVACY_MARK = '';

/** The consent sentence with its two documents as links, wherever the translation puts them. */
export function ConsentLabel({ legal }: { readonly legal: BrandLegal | undefined }): ReactNode {
  const { t } = useTranslation('console');
  if (legal === undefined) return t('signUp.consent.label');
  const template = t('signUp.consent.labelLinked', { terms: TERMS_MARK, privacy: PRIVACY_MARK });
  const terms = (
    <a href={legal.terms.url} target="_blank" rel="noopener noreferrer">
      {t('signUp.legal.terms')}
    </a>
  );
  const privacy = (
    <a href={legal.privacy.url} target="_blank" rel="noopener noreferrer">
      {t('signUp.legal.privacy')}
    </a>
  );
  return template
    .split(new RegExp(`(${TERMS_MARK}|${PRIVACY_MARK})`))
    .map((part, index) => (part === TERMS_MARK ? <span key={index}>{terms}</span> : part === PRIVACY_MARK ? <span key={index}>{privacy}</span> : part));
}
